import React from "react";
import TextMessage from "components/chat/TextMessage";
import ImageMessage from "components/chat/ImageMessage";
import TypingMessage from "./TypingMessage";
import AudioMessage from "components/chat/AudioMessage";

export default function Message({ message, inContext, canDelete = true, noMenu = false, renderContainer = true, canUseAsPrompt = true }) {

  if(message.cancelled) return null;

  if (message.type === "text") {
    return <TextMessage message={message} canUseAsPrompt={canUseAsPrompt} canDelete={canDelete} inContext={inContext} noMenu={noMenu} renderContainer={renderContainer} />;
  }

  if (message.type === "image") {
    return <ImageMessage message={message} canUseAsPrompt={false} canDelete={canDelete} noMenu={noMenu} renderContainer={renderContainer} />;
  }

  if(message.type === "pending") {
    return <TypingMessage message={message} inContext={false} renderContainer={renderContainer} />;
  }
  
  if(message.type === "audio") {
    return <AudioMessage message={message} inContext={inContext} noMenu={noMenu} renderContainer={renderContainer} />
  }

  console.log("Unknown message type", message.type);

  return null;
}
